import React, {Fragment} from 'react'

const About = () => {
    return (
        <Fragment>
            <h2>About this app</h2>
            <p>This is an app to search Github users</p>
            <p>Version: 1.0.0</p>
            <p>Developed by Aman Jaiswal</p>
         </Fragment>
    )
}

export default About